/**
 * 协议阅读弹窗事件名称枚举
 */
export enum AgreementsPopEvents {
  /** 弹窗显示状态更新 */
  UPDATE_SHOW = 'update:show',
  /** 协议签署完成 */
  AGREEMENT_CONFIRMED = 'agreement-confirmed',
  /** 用户关闭弹窗 */
  CLOSE = 'close',
  /** 用户取消操作 */
  CANCEL = 'cancel',
}
